import React from "react";
import { isMobile } from "react-device-detect";

const RegisterHelper = (props) => {
  return (
    <div className="Register__helper">
      <div className="Register--titles">
        <div className="Register--titles--inner">
          <h1>Create Account</h1>
          {isMobile ? (
            <div className="mobile-step">
              <div className={`step-one`}>1</div>
              <div className={`step-two`}>2</div>
            </div>
          ) : (
            <p>Set up your <span style={{ color: '#00b27e', fontWeight: 600 }}>FREE</span> account by following 2 steps</p>
          )}
        </div>
      </div>
      <div className="Register__steps">
        <div className={`Register--step ${props.pagination === 1 && "active"}`}>
          <div className="Register--step--inner">
            <h2>Step 1. Your account</h2>
            <p>Fill form with your personal info</p>
          </div>
        </div>
        <div className={`Register--step ${props.pagination === 2 && "active"}`}>
          <div className="Register--step--inner">
            <h2>Step 2. Company details</h2>
            <p>Fill form with your company info</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterHelper;
